import { instance } from '@/api/instances'

const requestMemberFile = async (store, { personId, fileId, fileType }) => {
  try {
    const response = await instance.get(
      `persons/${personId}/file_id/${fileId}?fileType=${fileType}`
    )

    return response
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'tertiaryIntention/requestMemberFile' },
      { root: true }
    )

    return []
  }
}

const getGuiasByMember = async (store, personId) => {
  try {
    const response = await instance.get(
      `persons/${personId}/tertiary_intention/guia`
    )

    return response
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'tertiaryIntention/getGuiasByMember' },
      { root: true }
    )

    return []
  }
}

const getCounterReferralsByMember = async (store, personId) => {
  try {
    const response = await instance.get(
      `/persons/${personId}/tertiary_intention/counter_referral/`
    )

    return response
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'tertiaryIntention/getCounterReferralsByMember' },
      { root: true }
    )

    return []
  }
}

const getCounterReferralDetails = async (store, { personId, id }) => {
  try {
    const data = await instance.get(
      `persons/${personId}/tertiary_intention/counter_referral/${id}/procedure`
    )
    return [false, data]
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'tertiaryCareMap/getCounterReferralDetails' },
      { root: true }
    )
    return [true, null]
  }
}

const getGuiaDetails = async (store, { personId, id }) => {
  try {
    const data = await instance.get(
      `persons/${personId}/tertiary_intention/guia/${id}/procedure`
    )
    return [false, data]
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'tertiaryCareMap/getGuiaDetails' },
      { root: true }
    )
    return [true, null]
  }
}

export default {
  requestMemberFile,
  getGuiasByMember,
  getCounterReferralsByMember,
  getCounterReferralDetails,
  getGuiaDetails
}
